import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setPageNumber } from "../../features/filter/filterSlice";

export default function Pagination() {
    const dispatch = useDispatch();
    const totalVideos = useSelector(state => state.videos.totalLength);
    const page = useSelector(state => state.filter.page);

    const contentPerPage = Math.ceil(totalVideos / 2);

    // console.log("pageNumber ", pageNumber);

    const handlePage = (pageNumber) => {
        dispatch(setPageNumber(pageNumber));
    };

    return (
        <section className="pt-12">
            <div className="max-w-7xl mx-auto px-5 py-6 lg:px-0 flex gap-2 justify-end">
                {[...Array(contentPerPage).keys()].map(element => 
                    <div 
                        className={`${ page === element + 1 ? "bg-green-600" : "bg-blue-600" } ${ page === element + 1 ? "text-blue" : "text-white"} px-4 py-1 rounded-full cursor-pointer`}
                        onClick = {() => handlePage(element + 1)}
                    >
                        
                        {element + 1}
                    </div>
                )}
            </div>
        </section>
    );
}
